import { createComponent } from '@helpers/admin';
import NumberPickerSection from '@template/blocks/NumberPickerSection/component';
import axios from 'axios';

export const NumberPicker = createComponent({
  label: 'Number Picker',
  component: NumberPickerSection,
  fields: {
    default: {
      label: 'Default Selected',
      type: 'object',
      objectFields: {
        countryCode: {
          label: 'Country',
          type: 'select',
          options: [
            {
              label: 'UK (+44)',
              value: '77',
              countryCode: '44',
              href: '/uk/',
              defaultArea: '020',
              area_codes: [],
            },
            {
              label: 'United States (+1)',
              key: 'US',
              value: '233',
              countryCode: '1',
              href: '/united-states/',
              defaultArea: '917',
              area_codes: [],
            },
            {
              label: 'Canada (+1)',
              key: 'CA',
              value: '38',
              countryCode: '1',
              href: '/canada/',
              defaultArea: '437',
              area_codes: [],
            },
            {
              label: 'France (+33)',
              key: 'FR',
              value: '75',
              countryCode: '33',
              href: '/france/',
              defaultArea: '170',
              area_codes: [],
            },
            {
              label: 'Germany (+49)',
              key: 'DE',
              value: '57',
              countryCode: '49',
              href: '/germany/',
              defaultArea: '030',
              area_codes: [],
            },
            {
              label: 'Ireland (+353)',
              key: 'IE',
              value: '102',
              countryCode: '353',
              href: '/ireland/',
              defaultArea: '01',
              area_codes: [],
            },
            {
              label: 'Italy (+39)',
              key: 'IT',
              value: '110',
              countryCode: '39',
              href: '/italy/',
              defaultArea: '06',
              area_codes: [],
            },
            {
              label: 'Spain (+34)',
              key: 'ES',
              value: '68',
              countryCode: '34',
              href: '/spain/',
              defaultArea: '919',
              area_codes: [],
            },
          ],
        },
        areaCode: {
          label: 'Area Code',
          type: 'select',
          options: [],
        },
        areaType: {
          label: 'Number Type',
          type: 'select',
          options: [],
        },
      },
    },
    altStyling: {
      label: 'Alternative Styling',
      type: 'boolean',
    },
    context: {
      label: 'Context',
      type: 'select',
      options: [
        { label: 'Standard', value: 'standard' },
        { label: 'Virtual Landline', value: 'virtualLandline' },
      ],
    },
  },
  // resolveFields: async (dataProps, params) => {
  //     const data = dataProps.props;
  //     const prevData = params.lastData.props;
  //     const fields = params.lastFields;
  //
  //     try {
  //         const currentCountryCode = data?.default?.countryCode;
  //         const lastCountryCode = prevData?.default?.countryCode;
  //
  //         const newAreaCodes = currentCountryCode ? await axios({
  //             method: "GET",
  //             url: `/svc/area-codes/${currentCountryCode}/dashboard-names`,
  //             headers: {
  //                 scheme: 'https'
  //             }
  //         }).then(res => res.data?.result) : [];
  //
  //         console.log(newAreaCodes)
  //
  //         return {
  //             ...fields,
  //             default: {
  //                 ...fields.default,
  //                 objectFields: {
  //                     ...fields.default['objectFields' as any],
  //                     areaCode: {
  //                         ...fields.default['objectFields' as any].areaCode,
  //                         options: []
  //                     }
  //                 }
  //             }
  //         };
  //     } catch (e) {
  //         return fields;
  //     }
  // }
});
